window.bundleDataQ = {
"Quinn-girl": {
displayName: "Quinn",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Quinn Personalized Coloring Experience",
variantId: "49608650916077",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Quinn_final_cover.png?v=1773443858",
price: "$14.99",
preorder: true
},
{
title: "Quinn Unicorn Holographic Sticker",
variantId: "49933756170477",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Quinn_holographic_sticker.png?v=1780099047",
price: "$4.99",
preorder: false
},
{
title: "Quinn Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} 


};